import { BdAdministrativeDistrictId } from './bd-administrative-district-id';

export const BD_ADMINISTRATIVE_DISTRICT_PLURALIZATION_MAPPING = {
  '=0': 'Kein Landkreis',
  '=1': '1 Landkreis',
  other: '# Landkreise',
};

export const BD_ADMINISTRATIVE_DISTRICT_SUFFIX_PLURALIZATION_MAPPING = {
  '=1': 'Landkreis',
  other: 'Landkreise',
};

export class BdAdministrativeDistrict {
  public static fromObjectArray(
    objArr: any[] = [],
  ): BdAdministrativeDistrict[] {
    const mapObjects = (obj: any): BdAdministrativeDistrict => {
      return BdAdministrativeDistrict.fromObject(obj);
    };

    return objArr.map(mapObjects);
  }

  public static fromObject(adObj: any = {}): BdAdministrativeDistrict {
    return new BdAdministrativeDistrict(
      BdAdministrativeDistrictId.create(adObj.id),
      adObj.name,
      adObj.otherName,
    );
  }

  constructor(
    public id: BdAdministrativeDistrictId,
    private name: string,
    private otherName: string,
  ) {}

  public displayName(): string {
    return this.otherName ?? this.name;
  }
}
